var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vue100vh',[_c('GMap',{ref:"main_map",staticClass:"col map",staticStyle:{"height":"100%","width":"100%"},attrs:{"map-type-id":"terrain","center":_vm.centerMap,"options":{
               zoomControl: false,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: false,
               disableDefaultUi: false,
               zoom: _vm.zoomMap
          }},on:{"center_changed":_vm.onCenterChanged}}),(!!(_vm.hasCoordinates))?_c('div',{staticClass:"markerFixed",staticStyle:{"pointer-events":"none"}},[_c('img',{staticClass:"marker",attrs:{"alt":"","src":require("../../assets/marker.png")}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }